const genreData = [
  {
    id: 13,
    name: "Simulator",
  },
  {
    id: 15,
    name: "Strategy",
  },
  {
    id: 31,
    name: "Adventure",
  },
  {
    id: 32,
    name: "Indie",
  },
  {
    id: 5,
    name: "Shooter",
  },
  {
    id: 9,
    name: "Puzzle",
  },
  {
    id: 14,
    name: "Sport",
  },
  {
    id: 33,
    name: "Arcade",
  },
  { id: 34, name: "Visual Novel" },
  {
    id: 7,
    name: "Music",
  },
  {
    id: 10,
    name: "Racing",
  },
  {
    id: 25,
    name: "Hack and slash/Beat 'em up",
  },
  {
    id: 8,
    name: "Platform",
  },
  {
    id: 4,
    name: "Fighting",
  },
  {
    id: 12,
    name: "Role-playing (RPG)",
  },
  {
    id: 16,
    name: "Turn-based strategy (TBS)",
  },
  {
    id: 26,
    name: "Quiz/Trivia",
  },
  {
    id: 11,
    name: "Real Time Strategy (RTS)",
  },
  {
    id: 24,
    name: "Tactical",
  },
  {
    id: 2,
    name: "Point-and-click",
  },
  {
    id: 30,
    name: "Pinball",
  },
  {
    id: 35,
    name: "Card & Board Game",
  },
];

export default genreData;
